import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Notification } from '../../../../interfaces/core/notification.entity';
import { NotificationService } from '../../../../services/notification.service';

@Component({
	selector: 'app-notifications',
	templateUrl: './notifications.component.html',
	styleUrls: ['./notifications.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class NotificationsComponent implements OnInit {
	@Input() mobileQuery: boolean = false;

	notifications: Notification[] = [];

	constructor(private notificationService: NotificationService) { }

	ngOnInit(): void {
		this.notificationService.getMyNotifications().subscribe(notifications => this.notifications = notifications);
	}

	closeNotification(notification_id: string){
		this.notificationService.markAsRead(notification_id).subscribe(() => {
			this.notifications = [...this.notifications].filter(n => n.id !== notification_id);
		});
	}

}
